import { render, staticRenderFns } from "./UploadLedger.vue?vue&type=template&id=4ea21f27&scoped=true"
import script from "./UploadLedger.vue?vue&type=script&lang=js"
export * from "./UploadLedger.vue?vue&type=script&lang=js"
import style0 from "./UploadLedger.vue?vue&type=style&index=0&id=4ea21f27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea21f27",
  null
  
)

export default component.exports